import { render, staticRenderFns } from "./bank-payment.vue?vue&type=template&id=76a5dc42&"
import script from "./bank-payment.vue?vue&type=script&lang=js&"
export * from "./bank-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports